import React from "react";

const AmountReview = ({
  id_R,
  closeAmountReviewOpen,
  isAmountReviewOpen,
  openLowerLoanAmount,
  openDetailsPageOpen,
  openLoanChecklistOpen,
  lowerAmount,
  progress,
}) => {
  const handleBackButton = () => {
    closeAmountReviewOpen();

    openDetailsPageOpen();
  };

  const handleNextButton = () => {
    closeAmountReviewOpen();

    openLoanChecklistOpen();
  };

  return (
    <>
      <div
        id={id_R}
        className={`${
          isAmountReviewOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen w-[60%] max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow  w-[100%] mx-auto h-[95vh] px-4">
            <div className="justify-end rounded-t flex items-end">
              <button
                onClick={closeAmountReviewOpen}
                type="button"
                className="bg-transparent rounded-lg text-sm p-2.5 ml-auto inline-flex items-center"
                data-modal-toggle={id_R}
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.84 12L5.7 8.9L3.9 12H0.2L3.88 6.3L0.1 0.839999H3.94L6.08 3.92L7.88 0.839999H11.58L7.84 6.46L11.68 12H7.84Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>

            <div className="flex items-center mt-10">
              <p className="text-[#000000] text-[20px] font-[700]">
                Approve Loan Amount
              </p>
            </div>
            <div className="flex items-center mt-2">
              <p className="font-[300] text-[15px] text-[#000000]">
                Review the requested loan amount and decide whether to approve
                it in full or adjust it based on eligibility.
              </p>
            </div>

            <div className="flex items-center justify-center mt-10">
              <p className="font-[400] text-[16px] text-[#000000]">
                Loan Amount Applied by the Member
              </p>
            </div>

            <div className="flex items-center justify-center mt-2">
              <div className="bg-[#F0FFFE] rounded-[4px] w-[300px] px-5 py-2">
                <p className="font-[400] text-[16px] text-[#074073]">
                  KES{" "}
                  {Number(lowerAmount || "0.00").toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </p>
              </div>
            </div>

            {progress != null && progress === 2 && (
              <div
                className="flex items-center justify-center mt-2 cursor-pointer"
                onClick={openLowerLoanAmount}
              >
                <div className="flex items-end justify-end w-[300px] mt-2">
                  <p className="font-[400] text-[16px] text-[#074073] underline">
                    Lower Loan Amount
                  </p>
                </div>
              </div>
            )}

            <div className="flex items-end justify-between w-[95%] h-[40vh] mt-5">
              <button
                onClick={handleBackButton}
                type="button"
                className="text-[#074073] font-[500] rounded-[5px] text-[16px] px-16 py-2 text-center 
                    bg-[#7FB8EB]"
              >
                Back
              </button>

              <button
                onClick={handleNextButton}
                type="button"
                className="text-white bg-[#074073] hover:bg-[#074073] focus:outline-none block rounded-[5px] text-[16px] font-[500] px-5 py-2.5 text-center"
              >
                Confirm Loan Amount
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AmountReview;
